// extracted by mini-css-extract-plugin
module.exports = {"newrace":"NewRaceForm_newrace__3k2oe","btn":"NewRaceForm_btn__25hB-","inputbox":"NewRaceForm_inputbox__2Ebsj","items":"NewRaceForm_items__1KxyG"};